import { IDanhSachPTTT } from "../models/NhapThongTinPTTTModel"
import { IThanhToan } from "../models/PhanHeChuyenKhoaModel"
import { IBangCheckIn, IXML2, IXML3, IXML4, IXML5 } from "../models/XMLModel"

export const fakeDataThanhToan: IThanhToan[] = [
  {
    ngayYLenh: "17:02 21/02/2024",
    trangThai: "",
    maTuongDuong: "",
    tenDichVu: "Phẫu thuật nâng ngực",
    doiTuong: "1",
    donVi: "Lần",
    soLuong: "1",
    donGia: "50.000",
    nguonChiTra: "Nguyễn Văn Liêm",
    giaBHYT: "30.000",
    ngayKetThuc: "21/02/2024",
    tyLeTT: "100%",
    bhThanhToan: "70%",
    tyLeBHYT: "70%",
    tranTt: "50%",
    mucHuong: "50%",
    mienGiam: "5.000",
    bnThanhToan: "15.000",
    cungChiTra: "0",
    tuChiTra: "100%",
    daThu: "0",
    conNo: "0",
    ycNop: "15.000",
    khoaChiDinh: "Khoa cấp cứu",
    phongChiDinh: "1",
    nguoiChiDinh: "Nguyễn Văn Bỉnh",
    phongThucHien: "2",
    nguoiThucHien: "Nguyễn Văn Lượng",
    loaiChiPhi: "BHYT",
    ghiChu: "",
  }
]

export const fakeDataBangCheckIn: IBangCheckIn[] = [
  {
    maThe: "MA_Lk",
    giaTri: "189",
    loi: ""
  },
  {
    maThe: "STT",
    giaTri: "1",
    loi: ""
  },
  {
    maThe: "MA_Lk",
    giaTri: "189",
    loi: ""
  },
  {
    maThe: "MA_BN",
    giaTri: "189",
    loi: ""
  },
  {
    maThe: "HO_TEN",
    giaTri: "Trần Miến",
    loi: ""
  },
]

export const fakeDataXML2: IXML2[] = [
  {
    maLk: "189",
    maThuoc: "05V.295",
    maCheBien: "",
    maCskcbThuoc: "",
    maNhom: "4",
    tenThuoc: "Bạch thược",
    donViTinh: "Gam",
    hamLuong: "",
    duongDung: "1.01",
    dangBaoChe: "",
    lieuDung: "1 liều/lần 1lần/ngày",
    cachDung: "",
    soDangKy: "",
    ttThau: "382/QĐ-BV;G5",
    phamVi: "2",
    tyLeTTBH: "0",
    soLuong: "1.000",
    donGia: "152.000",
    thanhTienBV: "152.000",
    thanhTienBH: "0.00",
    nguonKhacNSNN: "0.00",
    nguonKhacVTNN: "0.00",
    nguonKhacVTTN: "0.00",
    nguonKhacCL: "0.00",
    nguonKhac: "0.00",
    mucHuong: "0",
    BNTT: "152.000",
    BNCCT: "0.00",
    BHTT: "0.00",
    maKhoa: "K01",
    maBacSi: "165",
    maDichVu: "",
    ngayYLenh: "05/02/2024",
    maPTTT: "1",
    nguonCTRA: "4",
    vetThuong: "",
    duPhong: "",
  }
]

export const fakeDataXML3: IXML3[] = [
  {
    maLk: "101",
    maDichVu: "DV101",
    maPTTTQT: "PTTT101",
    maVatTu: "VT101",
    maNhom: "Nhom101",
    goiVTYT: "Goi101",
    tenVatTu: "Vật Tư 101",
    tenDichVu: "Dịch Vụ 101",
    maXangDau: "XD101",
    donViTinh: "Cái",
    phamVi: "Phạm Vi 101",
    soLuong: "15",
    donGiaBV: "12000",
    donGiaBH: "9000",
    ttThau: "Thầu 101",
    tyLeTTDV: "0.85",
    tyLeBH: "0.65",
    thanhTienBV: "180000",
    thanhTienBH: "117000",
    tranTT: "Trần 101",
    mucHuong: "Mục Hưởng 101",
    nguoiKhacNSNN: "Người Khác NSNN 101",
    nguoiKhacVTTN: "Người Khác VTTN 101",
    nguoiKhacVTNN: "Người Khác VTNN 101",
    nguoiKhacCL: "Người Khác CL 101",
    BNTT: "BNTT 101",
    BNCCT: "BNCCT 101",
    BHTT: "BHTT 101",
    maKhoa: "Khoa 101",
    maGiuong: "Giường 101",
    maBacSi: "Bác Sĩ 101",
    nguoiThucHien: "Người Thực Hiện 101",
    maBenh: "Bệnh 101",
    maBenhYHCT: "Bệnh YHCT 101",
    ngayYLenh: "2024-02-23",
    ngayTHYL: "2024-02-24",
    ngayKQ: "2024-02-25",
    maPTTT: "PTTT 101",
    vetThuong: "Vết Thương 101",
    voCam: "Vô Cảm 101",
    viTriTHDVKT: "Vị Trí THDVKT 101",
    maMay: "Máy 101",
    maHieuSP: "Hiệu Sản Phẩm 101",
    taiSuDung: "Tái Sử Dụng 101",
    duPhong: "Dự Phòng 101",
  },
  {
    maLk: "102",
    maDichVu: "DV102",
    maPTTTQT: "PTTT102",
    maVatTu: "VT102",
    maNhom: "Nhom102",
    goiVTYT: "Goi102",
    tenVatTu: "Vật Tư 102",
    tenDichVu: "Dịch Vụ 102",
    maXangDau: "XD102",
    donViTinh: "Cái",
    phamVi: "Phạm Vi 102",
    soLuong: "20",
    donGiaBV: "15000",
    donGiaBH: "11000",
    ttThau: "Thầu 102",
    tyLeTTDV: "0.9",
    tyLeBH: "0.7",
    thanhTienBV: "300000",
    thanhTienBH: "154000",
    tranTT: "Trần 102",
    mucHuong: "Mục Hưởng 102",
    nguoiKhacNSNN: "Người Khác NSNN 102",
    nguoiKhacVTTN: "Người Khác VTTN 102",
    nguoiKhacVTNN: "Người Khác VTNN 102",
    nguoiKhacCL: "Người Khác CL 102",
    BNTT: "BNTT 102",
    BNCCT: "BNCCT 102",
    BHTT: "BHTT 102",
    maKhoa: "Khoa 102",
    maGiuong: "Giường 102",
    maBacSi: "Bác Sĩ 102",
    nguoiThucHien: "Người Thực Hiện 102",
    maBenh: "Bệnh 102",
    maBenhYHCT: "Bệnh YHCT 102",
    ngayYLenh: "2024-02-26",
    ngayTHYL: "2024-02-27",
    ngayKQ: "2024-02-28",
    maPTTT: "PTTT 102",
    vetThuong: "Vết Thương 102",
    voCam: "Vô Cảm 102",
    viTriTHDVKT: "Vị Trí THDVKT 102",
    maMay: "Máy 102",
    maHieuSP: "Hiệu Sản Phẩm 102",
    taiSuDung: "Tái Sử Dụng 102",
    duPhong: "Dự Phòng 102",
  }
]

export const fakeDataXML4: IXML4[] = [
  {
    maLk: 'LK001',
    maDichVu: 'DV001',
    maChiSo: 'CS001',
    tenChiSo: 'Chỉ số 001',
    giaTri: '10',
    donViDo: 'Đơn vị 001',
    moTa: 'Mô tả 001',
    ketLuan: 'Kết luận 001',
  },
  {
    maLk: 'LK002',
    maDichVu: 'DV002',
    maChiSo: 'CS002',
    tenChiSo: 'Chỉ số 002',
    giaTri: '20',
    donViDo: 'Đơn vị 002',
    moTa: 'Mô tả 002',
    ketLuan: 'Kết luận 002',
  },
  {
    maLk: 'LK003',
    maDichVu: 'DV003',
    maChiSo: 'CS003',
    tenChiSo: 'Chỉ số 003',
    giaTri: '30',
    donViDo: 'Đơn vị 003',
    moTa: 'Mô tả 003',
    ketLuan: 'Kết luận 003',
  },
];

export const fakeDataXML5: IXML5[] = [
  {
    maLk: "101",
    dienBienLS: "Diễn biến 1",
    giaiDoanBenh: "Giai đoạn 1",
    hoiChan: "Hội chẩn 1",
    phauThuat: "Phẫu thuật 1",
    thoiDiemDBLS: "2024-02-23",
    nguoiThucHien: "Người thực hiện 1",
    duPhong: "Dự phòng 1",
  },
  {
    maLk: "102",
    dienBienLS: "Diễn biến 2",
    giaiDoanBenh: "Giai đoạn 2",
    hoiChan: "Hội chẩn 2",
    phauThuat: "Phẫu thuật 2",
    thoiDiemDBLS: "2024-02-24",
    nguoiThucHien: "Người thực hiện 2",
    duPhong: "Dự phòng 2",
  },
  {
    maLk: "103",
    dienBienLS: "Diễn biến 3",
    giaiDoanBenh: "Giai đoạn 3",
    hoiChan: "Hội chẩn 3",
    phauThuat: "Phẫu thuật 3",
    thoiDiemDBLS: "2024-02-25",
    nguoiThucHien: "Người thực hiện 3",
    duPhong: "Dự phòng 3",
  },
];

export const fakeDataDSMau = [
  {
    tenMau: "Mẫu 1"
  },
  {
    tenMau: "Mẫu 2"
  },
  {
    tenMau: "Mẫu 3"
  },
]

export const fakeDataDanhSachPTTT: IDanhSachPTTT[] = [
  {
    batDau: "01/01/2022",
    ketThuc: "10/01/2022",
    nguoiThucHien: "Người 1",
    ngayNhap: "05/01/2022",
    nguoiNhap: "Người nhập 1",
    dichVu: "Dịch vụ 1",
    loaiPTTT: "Loại 1",
  },
  {
    batDau: "02/01/2022",
    ketThuc: "15/01/2022",
    nguoiThucHien: "Người 2",
    ngayNhap: "08/01/2022",
    nguoiNhap: "Người nhập 2",
    dichVu: "Dịch vụ 2",
    loaiPTTT: "Loại 2",
  },
  {
    batDau: "03/01/2022",
    ketThuc: "20/01/2022",
    nguoiThucHien: "Người 3",
    ngayNhap: "12/01/2022",
    nguoiNhap: "Người nhập 3",
    dichVu: "Dịch vụ 3",
    loaiPTTT: "Loại 3",
  },
];